import "./navbar.scss"
import Hamburger from 'hamburger-react'

export default function navbar({menuOpen, setMenuOpen}) {
    return (
        <div className={"navbar " + (menuOpen && "active")}>
            <div className="wrapper">
                <div className="left">
                    <a href="#home" className="homelogo"> {">"}$cd /home<span></span></a>
                </div>
                
                <div className="right">
                    <Hamburger toggled={menuOpen} toggle={setMenuOpen} size={25}/>
                </div>
            </div>
        </div>
    )
}
